// src/component/VideoRow/VideoRowPlaylist.js
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import { useGetPlaylistsByCategoryAndNetworkQuery } from "../../services/modules/playlistCategory";
import { setVideosByKey } from "../../store/video";
import { titleToKey } from "../../services/utils/helpers.js";

import Loader from "../../component/ui/Loader.js";
import Heading from "../../component/ui/Heading.js";
import ButtonsPreview from "../../component/previews/ButtonsPreview.js";
import PreviewImage from "../../component/previews/PreviewImage.js";

import useSwipeScroll from "../../hooks/useSwipeScroll.js";

function VideoRowPlaylist({ title, coverImage, categoryId }) {
  const dispatch = useDispatch();
  const rowRef = useRef(null);

  // Abilita swipe/drag e wheel-to-horizontal
  useSwipeScroll(rowRef, { friction: 1, enableWheelX: true });

  const { data, isLoading, error } =
    useGetPlaylistsByCategoryAndNetworkQuery({ categoryId });

  const videos = (() => {
    const result = data?.data?.result;
    if (Array.isArray(result?.playlists)) {
      //era return result.playlists.map((playlist) => ({
        
      const randomizedPlaylists = [...result.playlists];

      for (let i = randomizedPlaylists.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [randomizedPlaylists[i], randomizedPlaylists[j]] = [randomizedPlaylists[j], randomizedPlaylists[i]];
      }

      return randomizedPlaylists.map((playlist) => ({
        id: playlist.id,
        title: playlist.name,
        thumbnail: playlist.coverImage,
        rating: 0,
        url: null,
        description: playlist.description,
        createdAt: playlist.createdAt,
        categories: Array.isArray(playlist.playlistCategory)
          ? playlist.playlistCategory
          : [],
        videos: {
          thumbnail: playlist.coverImage,
          coverImage: playlist.coverImage,
          videos: (playlist.videos || []).map((pv) => ({
            id: pv.videoId,
            title: pv.video?.title,
            thumbnail: pv.video?.thumbnail,
            rating: pv.video?.rating || 0,
            url: pv.video?.url,
            description: pv.video?.description,
            createdAt: pv.video?.createdAt,
            categories: Array.isArray(pv.video?.categories) ? pv.video.categories : [],
          })),
        },
      }));
    }
    return [];
  })();

  useEffect(() => {
    if (Array.isArray(videos) && videos.length) {
      videos.forEach((pl) => {
        dispatch(
          setVideosByKey({
            key: "playlist_" + titleToKey(pl.title),
            videos: pl.videos, // oggetto { thumbnail, coverImage, videos:[...] }
            title: pl.title,
            playlists: pl,
          })
        );
      });
    }
  }, [videos, dispatch]);

  if (isLoading) return <Loader />;
  if (error || !videos.length) return null;

  return (
    <section className="mt-8">
      <Heading categoryId={categoryId} title={titleToKey(title)}>
        {title}
      </Heading>

      <div className="relative">
        <ButtonsPreview
          ribbon={rowRef}
          length={videos.length}
          isScrollByOne={true}
        />

        <div
          data-xscroll
          ref={rowRef}
          className="
            flex overflow-x-auto scroll-smooth scrollbar-hide mt-3
            gap-[100px] items-center cursor-grab select-none
          "
          style={{
            WebkitOverflowScrolling: "touch",
            touchAction: "pan-x",
            overscrollBehaviorX: "contain",
          }}
        >
          <div className="grid grid-flow-col auto-cols-[320px] gap-[15px]">

            {videos.map((video) => (
              <div key={video.id} className="relative flex items-start">
                <div
                  style={{ flexBasis: 320 }}
                  className="block flex-shrink-0"
                >
                  <Link
                    to={`/playlist/${titleToKey(video.title)}`}
                    state={{ video }}
                    className="block w-full"
                  >
                    <PreviewImage media={video} type="tv" hud />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default VideoRowPlaylist;
